"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = theme => ({
  avatar: {
    borderRadius: '50%',
    backgroundColor: theme.avatar.background,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.avatar.color,
    position: 'relative',
    userSelect: 'none',
    fontSize: theme.avatar.fontSize.body,
    fontWeight: theme.avatar.fontWeight.normal,
    '& > .status': {
      position: 'absolute',
      bottom: 0,
      right: 0
    }
  },
  small: {
    height: theme.avatar.size.small,
    width: theme.avatar.size.small,
    fontSize: theme.avatar.fontSize.small,
    fontWeight: theme.avatar.fontWeight.semibold,
    '& > .status': {
      bottom: -1,
      right: -1
    }
  },
  medium: {
    height: theme.avatar.size.medium,
    width: theme.avatar.size.medium,
    '& > .status': {
      bottom: -2,
      right: -2
    }
  },
  large: {
    height: theme.avatar.size.large,
    width: theme.avatar.size.large,
    '& > .status': {
      bottom: -2,
      right: -2
    }
  },
  xlarge: {
    height: theme.avatar.size.xlarge,
    width: theme.avatar.size.xlarge,
    fontSize: theme.avatar.fontSize.xlarge,
    fontWeight: theme.avatar.fontWeight.semibold,
    '& > .status': {
      bottom: -4,
      right: -4
    }
  },
  xxlarge: {
    height: theme.avatar.size.xxlarge,
    width: theme.avatar.size.xxlarge,
    fontSize: theme.avatar.fontSize.xlarge,
    fontWeight: theme.avatar.fontWeight.semibold,
    '& > .status': {
      bottom: -4,
      right: -4
    }
  }
});
exports.default = _default;